import { calculateValuePerMetrics } from "@project-rouge/service-cost-client/data/value-per-metric";

export function CalculateCostPerValues(total: number, units: number, area: number) {
  const values = calculateValuePerMetrics(total, units, area);

  return values;
}
